import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Tab, Tabs } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import HubIcon from '@mui/icons-material/Hub';
import { saveAppConfigData } from '@/src/datastore/slices/appConfigData';

type GraphTableSwitcherPropType = {
  handleChangeTab: (newValue: number) => void;
  selectedTabValue: number | null;
  disableTabs?: boolean;
};

const GraphTableSwitcher = (props: GraphTableSwitcherPropType) => {
  const { handleChangeTab, selectedTabValue = 0, disableTabs } = props;

  const dispatch = useDispatch();
  const [value, setValue] = useState<number>(selectedTabValue ?? 0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (disableTabs) return;
    setValue(newValue);
    handleChangeTab(newValue);
    dispatch(saveAppConfigData({ selectedTabValue: newValue }));
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="icon label tabs example"
      sx={{
        '& .MuiTabs-indicator': {
          backgroundColor: disableTabs ? 'transparent' : undefined
        }
      }}
    >
      <Tab
        icon={<TableChartIcon />}
        label="Table view"
        sx={{
          textTransform: 'none',
          opacity: disableTabs ? 0.5 : 1,
          pointerEvents: disableTabs ? 'none' : 'auto'
        }}
        disabled={disableTabs}
      />
      <Tab
        icon={<HubIcon />}
        label="Graph view"
        sx={{
          textTransform: 'none',
          opacity: disableTabs ? 0.5 : 1,
          pointerEvents: disableTabs ? 'none' : 'auto'
        }}
        disabled={disableTabs}
      />
    </Tabs>
  );
};

export default GraphTableSwitcher;
